<template>
  <div class="orderpaycontain">
    <!-- <div class="orderheader">查看</div> -->
    <!-- <div id="top">
      
   <header-box title='20220711健康管理师考证理论…'></header-box>    
   
    </div> -->
    <!-- <div class="ordernav"><span class="nopay" @click="nopay">未支付</span><span @click="ispay" class="ispay">已完成</span></div> -->
    
 
  <div class="ordernum"><div ><span class="examl">订单编号：</span>LM202271101                      <span style="float: right;">订单已完成</span></div>
   <!-- <span  class="ordernum_ing">订单已完成</span> -->
   
   <!-- <span v-else class="ordernum_ing">订单已完成</span> -->


  </div>
   <div class="orderbottom">
 <div class="ordercontent"><span class="examl">考试名称</span> <span class="examr">20220711健康管理师考证理论知识考试</span></div> 
<div class="ordercontent"><span class="examl">考试科目</span> <span class="examr">理论</span></div> 
  <div class="ordercontent"><span class="examl">考试工种</span> <span class="examr">健康管理师</span></div> 
 <div class="ordercontent"><span class="examl">考试等级</span> <span class="examr">三级高级工</span></div> 
 <div class="ordercontent"><span class="examl">支付人数</span> <span class="examr">50人</span></div> 
 <!-- <div class="ordercontent"><span class="examl">考生名字</span> <span class="examr">五覅哦加哦加哦加哦</span></div> 
 <div class="ordercontent"><span class="examl">性别</span> <span class="examr">女</span></div> 
 
 <div class="ordercontent"><span class="examl">联系方式</span> <span class="examr">五覅哦加哦加哦加哦</span></div> -->
 
 <div class="ordercontent"><span class="examl">付款方式</span> <span class="examr">线上付款</span></div>
  <div class="ordercontent"><span class="examl">付款金额</span> <span class="examr">￥10000.00</span></div>
   <div class="ordercontent"><span class="examl">付款时间</span> <span class="examr">2022-08-04 010:10:00</span></div> 

   <!-- <div class="jigou_pay"> <span></span>应付：<span> ￥</span> <span> 10000</span></div> -->
   </div>
 
    
  </div>
</template>
<script>
import headerBox from '@/components/header.vue'
export default {
  components:{
headerBox,
  },
  data(){
    return{
   shownopay:false
} 
  },
  methods:{
 
  },
  mounted(){
  this.shownopay=Number(this.$route.query.lookbool)
  }
 
}
</script>
<style lang="less" scoped>
.orderpaycontain{
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 32px;
  background: rgb(228, 228, 230);
  width: 100%;
  height: 100vh;
}
 #top {

  text-align: center;
 height: @headerh;
   box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}
.orderpaycontain .orderheader{
  text-align: center;
}
 
.orderpaycontain .ordernum{
    position: relative;
    background: white;
    border-bottom: 1px solid #edebeb;
}
.orderpaycontain .ordernum_ing{
  position: absolute;
  right: @paddingpay;
  top: 0;
  color: rgb(182, 179, 179);
}

 
.orderpaycontain .orderbottom{
  background: @whitee;
  border-bottom: @allboxbordermin;
  .jigou_pay{
    display: flex;
    justify-content: flex-end;
    border-top: @allboxbordermin;
    background: @whitee;
    height: 104px;
    align-items: center;
    span:nth-child(1){
color: rgb(182, 179, 179);
    }
 span:nth-child(2){
  color: red;      
    }
 span:nth-child(3){
     color: red;   
     font-size: 48px;
        
    }
  }
}
.orderpaycontain .orderbottom .ordercontent .examl{
color: rgb(182, 179, 179);
width: 160px;
font-size: 28px;
}
.orderpaycontain .orderbottom .ordercontent {
display: flex;
}
.orderpaycontain .orderbottom .ordercontent .examr{
color: black;
flex: 1;
padding: 0 0 20px 0;
}
.orderpaycontain .ordernum{
  height: 76px;
  line-height: 76px;
}
.orderpaycontain .ordernum,.orderpaycontain .orderbottom{
padding: 0 @paddingpay;

}
 
.orderbottom .ordercontent:nth-child(1){
  padding-top: @paddingpay;
}
</style>
